/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Ai_PcInputs */

const en_pc_cmp_r_ai_pc = /** @type {(inputs: Pc_Cmp_R_Ai_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring your own agent through the MCP server`)
};

const zh_pc_cmp_r_ai_pc = /** @type {(inputs: Pc_Cmp_R_Ai_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过 MCP 服务器接入你自己的智能体`)
};

/**
* | output |
* | --- |
* | "Bring your own agent through the MCP server" |
*
* @param {Pc_Cmp_R_Ai_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_ai_pc = /** @type {((inputs?: Pc_Cmp_R_Ai_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Ai_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_ai_pc(inputs)
	return zh_pc_cmp_r_ai_pc(inputs)
});
export { pc_cmp_r_ai_pc as "pc.cmp.r.ai.pc" }